webpackJsonp([116137471943794],{

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactstrap = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Advanced = function Advanced() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactstrap.Jumbotron,
	      { fluid: true },
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          'h1',
	          { className: 'display-3' },
	          'Appendix'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'lead' },
	          'Topics for experienced keepers and references'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactstrap.Container,
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'References'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Lewbart, G. A. (Ed.). (2011). ',
	          _react2.default.createElement(
	            'a',
	            { href: 'http://amzn.to/2EtDfOg' },
	            'Invertebrate medicine.'
	          ),
	          ' John Wiley & Sons. Chicago '
	        )
	      )
	    )
	  );
	};
	
	exports.default = Advanced;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-appendix-js-e76c2903e09f2013278a.js